var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-tab',{attrs:{"id":"machineLearning","md-label":"Machine learning"}},[_c('MLcomponent',{attrs:{"data":_vm.mlalgorithm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }